var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.5 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 20.0952C20.5746 20.0953 21 20.5217 21 21.0476C20.9999 21.5735 20.5746 21.9999 20.05 22H4.84987C4.32524 22 3.89993 21.5735 3.89986 21.0476C3.89986 20.5216 4.3252 20.0952 4.84987 20.0952H20.05Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4499 4.38082C16.1226 4.38089 19.1 7.36566 19.1 11.0475V17.7143C19.0999 18.2401 18.6745 18.6666 18.15 18.6666H6.74989C6.22526 18.6666 5.79995 18.2402 5.79988 17.7143V11.0475C5.79988 7.36562 8.77722 4.38082 12.4499 4.38082ZM12.4499 6.2856C9.82657 6.2856 7.69989 8.4176 7.69989 11.0475V16.7619H17.2V11.0475C17.2 8.41764 15.0732 6.28567 12.4499 6.2856Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04902 6.93665C2.21504 6.43783 2.75279 6.16859 3.25044 6.33489L4.67546 6.81109C5.17293 6.97759 5.44157 7.51667 5.2757 8.01552C5.10967 8.51424 4.57187 8.78346 4.07428 8.61728L2.64927 8.14108C2.15172 7.97465 1.88319 7.43553 2.04902 6.93665Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70318 3.70745C4.07418 3.33552 4.67555 3.33553 5.04655 3.70745L6.47156 5.13604C6.84241 5.50798 6.84251 6.11089 6.47156 6.48277C6.10061 6.85462 5.4992 6.85453 5.12819 6.48277L3.70318 5.05419C3.33219 4.68227 3.33221 4.07939 3.70318 3.70745Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9243 2.04915C7.42194 1.88289 7.95971 2.1521 8.12573 2.6509L8.60073 4.07948C8.76647 4.57831 8.49795 5.11748 8.00048 5.28392C7.50289 5.4502 6.96516 5.18085 6.79906 4.68216L6.32405 3.25358C6.15817 2.75468 6.42673 2.21559 6.9243 2.04915Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.31f5cd327b9083941cfc4f54d8f4d562.svg";
export { ForwardRef as ReactComponent };